export const isDevelopment = () =>
  (typeof location !== 'undefined' && location.hostname.endsWith('.app.local')) || location.hostname === 'localhost'
